import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AppComponent} from './app.component';
import {FormsModule} from '@angular/forms';
import {AppRoutingModule} from './app-routing.module';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {FlexLayoutModule} from '@angular/flex-layout';
import {MydocmaStepperModule} from 'projects/mydocma/import-export/src/lib/stepper/stepper.module';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {MatButtonModule} from '@angular/material/button';
import {FileType, ModuleTranslateLoader} from '@larscom/ngx-translate-module-loader';
import {TranslateLoader, TranslateModule, TranslateService} from '@ngx-translate/core';
import {MatIconModule, MatMenuModule, MatRadioModule} from '@angular/material';
import 'hammerjs';
import {MatTabsModule} from '@angular/material/tabs';
import {AppImportStepperComponent} from './components/import-stepper/app-import-stepper.component';
import {ImportComponent} from './components/import/import.component';
import {DragDropFileUploadModule} from '@mydocma/component-library/src/lib/drag-drop-file-upload';
import {MydocmaImportModule} from '../../projects/mydocma/import-export/src/lib/import/import.module';
import {StepperService} from '../../projects/mydocma/import-export/src/lib/stepper/stepper.service';
import {ExportComponent} from './components/export/export.component';
import {AppExportStepperComponent} from './components/export-stepper/app-export-stepper.component';
import {MydocmaExportModule} from '../../projects/mydocma/import-export/src/lib/export/export.module';
import { StepperNavigationComponent } from './components/stepper-navigation/stepper-navigation.component';
import { Step1Component } from './components/stepper-navigation/step1/step1.component';
import { Step2Component } from './components/stepper-navigation/step2/step2.component';
import { Step3Component } from './components/stepper-navigation/step3/step3.component';
import { LoaderModule } from '@mydocma/component-library';

export function createTranslateLoader(http: HttpClient) {
    const baseTranslateUrl = './assets/i18n';

    return new ModuleTranslateLoader(http, {
        modules: [
            {baseTranslateUrl, fileType: FileType.JSON},
            {moduleName: 'ie', baseTranslateUrl, fileType: FileType.JSON},
            {moduleName: 'comp-lib', baseTranslateUrl, fileType: FileType.JSON},
        ],
    });
}

@NgModule({
    declarations: [
        AppComponent,
        AppImportStepperComponent,
        ImportComponent,
        AppExportStepperComponent,
        ExportComponent,
        StepperNavigationComponent,
        Step1Component,
        Step2Component,
        Step3Component,
        
    ],
    imports: [
        AppRoutingModule,
        BrowserAnimationsModule,
        BrowserModule,
        DragDropFileUploadModule,
        HttpClientModule,
        FlexLayoutModule,
        FormsModule,
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatTabsModule,
        MatRadioModule,
        MydocmaExportModule,
        MydocmaImportModule,
        MydocmaStepperModule,
        LoaderModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient],
            },
        })
    ],
    providers: [StepperService],
    bootstrap: [AppComponent]
})
export class AppModule {

    constructor(
        private translate: TranslateService,
    ) {
        this.translate.addLangs(['en', 'de']);
        this.translate.setDefaultLang('de');
        this.translate.use('de');
    }
}
